import type { FeaturedCardInput } from "@/types/featuredCard";
export interface Input extends FeaturedCardInput {}

<li class=["featured-card", input.theme && `theme-${input.theme.themeName}`]>
  <a
    class="featured-card__storefront-link"
    href=input.storefrontUrl
    on-click("handleStorefrontClick")
  >
    <div class="featured-card__storefront-content">
      <h3 class="featured-card__storefront-name">
        ${input.firstName} ${input.lastName}
      </h3>
      <p class="featured-card__storefront-description">
        ${input.description}
      </p>
      <div class="featured-card__storefront-cta">
        <ebay-button size="small" tabindex="-1">
          <if(input.ctaText)>
            <span>${input.ctaText}</span>
          </if>
          <else>
            <span>Shop ${input.firstName}'s picks</span>
          </else>
        </ebay-button>
      </div>
    </div>

    <div class="featured-card__storefront-images">

      <div class="featured-card__storefront-image">
        <img
          src=(input.profileImage.imageUrl)
          alt=`${input.firstName} ${input.lastName}`
          loading="lazy"
        >
      </div>
      <for|product| of=input.products>
        <div class="featured-card__storefront-image featured-card__storefront-image--scrim">
          <img src=product.imageUrl alt="" loading="lazy">
        </div>
      </for>
    </div>
  </a>
</li>
